import Reports from '../../../components/reports/Reports.jsx';
import InlineComponent from './inlineComponent.jsx';

module.exports = class reports extends InlineComponent {
  define() {
    this.component = Reports;
  }
};
